import { AppBar, styled } from '@mui/material';

export const AssessmentsHeaderContainer = styled(AppBar)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  boxShadow: theme.shadows[1],
  elevation: 1,
  padding: theme.spacing(3),
  gap: theme.spacing(3),
}));
